import { render, staticRenderFns } from "./TipsCoupon.vue?vue&type=template&id=33a3aff8&scoped=true&"
import script from "./TipsCoupon.vue?vue&type=script&lang=ts&"
export * from "./TipsCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./TipsCoupon.vue?vue&type=style&index=0&id=33a3aff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3aff8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VRadio,VRadioGroup})
